module.exports = __webpack_public_path__ + "img/8c629ce.jpg";